import { useState } from "react";
import { Eye, EyeOff, Mail } from "lucide-react";
import { Button } from "./ui/button";

interface EmailMaskProps {
  email: string;
  show?: boolean;
  className?: string;
}

export function EmailMask({ email, show = false, className = "" }: EmailMaskProps) {
  const [isRevealed, setIsRevealed] = useState(show);

  if (!email) {
    return <span className="text-muted-foreground">N/A</span>;
  }

  const maskEmail = (e: string): string => {
    const [local, domain] = e.split("@");
    if (!domain) return "***";
    const visible = Math.min(local.length, 2);
    return local.slice(0, visible).padEnd(local.length, "*") + "@" + domain;
  };

  const handleReveal = () => {
    setIsRevealed(!isRevealed);
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Mail className="w-4 h-4 text-muted-foreground shrink-0" />
      {isRevealed ? (
        <span className="font-mono text-sm">{email}</span>
      ) : (
        <span className="font-mono text-sm text-muted-foreground">{maskEmail(email)}</span>
      )}
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-6 w-6 p-0"
        onClick={handleReveal}
        title={isRevealed ? "Hide email" : "Reveal email"}
      >
        {isRevealed ? <EyeOff className="w-3.5 h-3.5" /> : <Eye className="w-3.5 h-3.5" />}
      </Button>
    </div>
  );
}